var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninTextBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 55,
    viewBox: "0 0 123 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0915 0C12.3595 0 6.09149 6.26801 6.09149 14V32C6.09149 33.7354 6.40725 35.3971 6.98446 36.9307L0.189955 51.7827C-0.621658 53.5568 1.3273 55.3243 3.0139 54.3437L17.7119 45.7986C18.4853 45.931 19.2803 46 20.0915 46H108.091C115.823 46 122.091 39.732 122.091 32V14C122.091 6.26801 115.823 0 108.091 0H20.0915Z",
    fill: "#E7D5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninTextBg);
export default __webpack_public_path__ + "static/media/signin_text_bg.5433bf6a4bfab510e62289481ab4a004.svg";
export { ForwardRef as ReactComponent };